<template>
  <section>
    <div class="home-slider" v-if="sponsors">
      <div class="slider-holder" :style="`width:100%;display:flex;flex-direction:${isVertical ? 'row' : 'column-reverse'}`">
        <div class="thumb-main">
          <VueSlickCarousel ref="thumbnails" :arrows="false" :centerMode="true" :autoplay="true" :swipeToSlide="true" :verticalSwiping="true" :focusOnSelect="true" :slidesToShow="3"
            :vertical="isVertical" :v-bind="thumbnails" :asNavFor="$refs.main">
              <img v-for="(slide) in sponsors" :key="slide.id" :src="slide.image" />
          </VueSlickCarousel>
        </div>
        <div class="slide-main">
          <VueSlickCarousel ref="main" @beforeChange="changeSlider" :autoplay="true" :focusOnSelect="true" :v-bind="main"
            :asNavFor="$refs.thumbnails">
            <div class="slide" v-for="(slide, index) in sponsors" :key="index" :class="`slide--${index}`">
              <div class="row">
                <div class="col-sm-12 col-md-10 offset-md-2 q-pb-md slide-margin">
                  <div class="row">
                    <!-- <div class="col-12 timing"><span><b>12</b> Days</span> <span><b>12</b> Hours</span> <span><b>12</b>
                        Minutes</span></div> -->
                    <div class="col-sm-7 col-md-7 the-text">
                      <p>Global Competition</p>
                      <p>World <span>Robot</span> Olympiad</p>
                    </div>
                    <div class="col-12 col-sm-5 col-md-5 img">
                      <div class="the-img">
                        <img src="@/assets/img/home/slider-img2.png">
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <!-- read more button -->
                      <div class="the-button">
                        <button class="wro-button secondaryButtons" @click.prevent="readMore"><span>Join
                            Now</span></button>
                        <span class="skew-line-w"></span>
                      </div>
                      <!-- end read more  button -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent.vue";
import { VueAgile } from 'vue-agile'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: { ButtonComponent, agile: VueAgile, VueSlickCarousel },
  data() {
    return {
      isVertical: true,
      slide: 'style',
      lorem: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque voluptatem totam, architecto cupiditate officia rerum, error dignissimos praesentium libero ab nemo.',

      main: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        autoplay: true,
        infinite: true,
        speed: 3000,
        autoplaySpeed: 3000,
        cssEase: "linear"
      },

      thumbnails: {
        speed: 3000,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        infinite: true,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        verticalSwiping: true,
        swipeToSlide: true,
        arrows: false,
        autoplay: true
      },

      slides: [
        require('@/assets/img/home/Leadership-Institute.jpg'),
        require('@/assets/img/home/Saudi-Arabia.jpg'),
        require('@/assets/img/home/tahakom.jpg'),
        require('@/assets/img/home/Leadership-Institute.jpg'),
        require('@/assets/img/home/Saudi-Arabia.jpg'),
        require('@/assets/img/home/tahakom.jpg'),
      ],
      sponsors: []
    }
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    }
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  mounted() {
    this.$API.general.getSponsors()
      .then(response => {
        this.sponsors = response;
      });
    this.$refs.thumbnails.goTo(3);
    this.myEventHandler()
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    changeSlider (e) {
      this.$refs.thumbnails.goTo(e);
    },
    readMore() {
      if(this.userData) {
        this.$router.push('/competitions')
      } else {
        this.$router.push('/sign-In')
      }
      
    },
    scroll() {
      window.location.href = '#virtual-games';
    },
    myEventHandler() {
      if(window.innerWidth <= 820) {
        this.isVertical = false;
      } else {
        this.isVertical = true;
      }
    }
  }
}
</script>


<style>
.home-slider {
  height: 88vh;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  position: relative;
  top: 0;
}

.home-slider .slider-holder {
  width: 100%;
}

.home-slider .slider-holder .timing {
  display: block;
  text-align: center;
  margin: 5% 0;
}

.home-slider .slider-holder .timing span {
  font-size: 1.3rem;
  color: var(--mainColors);
  font-weight: 500;
  margin: 0 10px;
}

.home-slider .slider-holder .timing span b {
  font-size: 2rem;
  color: #7C7C7C;
  font-weight: 500;
}

.home-slider .slider-holder .q-carousel__slide {
  background-image: none !important;
}

/* the-text content style css */

.home-slider .slider-holder .the-text {
  padding: 24px 0px 0px;
}

.home-slider .slider-holder .the-text p {
  color: var(--secondaryColors);
}

.home-slider .slider-holder .the-text p:nth-child(1) {
  font-size: 1.25rem;
  color: var(--mainColors);
}

.home-slider .slider-holder .the-text p:nth-child(2) {
  font-size: 3.75rem;
  margin: 18px 0px 13px !important;
  line-height: 1em;
  font-weight: 500;
}

.home-slider .slider-holder .the-text p:nth-child(2) span {
  color: var(--mainColors);
}

.home-slider .slider-holder .the-text p:nth-child(3) {
  font-size: 1.125rem;
  margin-bottom: 10.2px !important;
}

.home-slider .slider-holder .the-button {
  margin-top: 50px !important;
}

.home-slider .slider-holder .the-button .wro-button {
  margin-left: 0px;
  width: 205px;
  height: 60px;
  border-radius: 30px;
}

.home-slider .slider-holder .the-button .wro-button:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 15px;
  left: 15px;
  border-radius: 30px;
  z-index: -1;
  transition: 0.5s ease all;
  background-color: white;
  border: 1px solid var(--mainColors);
}

.home-slider .slider-holder .the-button .wro-button span {
  font-size: 1.253rem;
  font-weight: 500;
}

.home-slider .slider-holder .the-button .wro-button:hover:after {
  top: 0;
  left: 0;
}

/* end the-text content style css */

/* start the-img slider css */

.home-slider .slider-holder .the-img {
  text-align: center;
}

.home-slider .slider-holder .the-img img {
  width: auto;
  /* -webkit-box-shadow: -25px 30px 0px 2px var(--mainColors);
  -moz-box-shadow: -25px 30px 0px 2px var(--mainColors);
  box-shadow: -25px 30px 0px 2px var(--mainColors); */
  transition: 0.5s ease all;
}

.home-slider .slider-holder .the-img:hover img {
  /* -webkit-box-shadow: 0px 2px 0px 0px var(--mainColors);
  -moz-box-shadow: 0px 2px 0px 0px var(--mainColors);
  box-shadow: 0px 2px 0px 0px var(--mainColors); */
}

.thumb-main{ width: 220px; height: 100%;}
.thumb-main .slick-list{ padding: 0 !important;}
.thumb-main .slick-list .slick-slide{ padding: 0 40px 0 0}
.thumb-main .slick-list .slick-slide div{ width: 180px; height:180px;position: relative; left: 0;top: 0;transform: scale(0.6); transition: transform .5s ease; }
.thumb-main .slick-list .slick-slide img{ border: 2px solid #cacaca; display: block !important; border-radius: 50%; height:100%;width:99.5% !important}
.thumb-main .slick-list .slick-current{ position: relative; left: 40px;}
.thumb-main .slick-list .slick-current div{ transform: scale(1);}
.thumb-main .slick-list .slick-current img{ border: 1px solid var(--mainColors);}
.slide-margin {margin-top:12%}
.slide-main{ width: 75%; left: 10%; position: relative;}
.slick-arrow {background: transparent;
  border: none;
  width: 24px; height: 40px;
  cursor: pointer;
  font-size: 0px;
  transition-duration: 0.3s;
  position: absolute;
  top: 54%;  
  transform: translateY(-50%);
  z-index: 10;
}
.slick-prev{ background-image:url("~@/assets/img/home/arw-l.png"); background-repeat: no-repeat; background-position: center; left:0;}
.slick-next{ background-image:url("~@/assets/img/home/arw-r.png"); background-repeat: no-repeat; background-position: center; right:0px;}

/* start the-img slider css */

.home .more {
  text-align: center;
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translate(-50%);
  cursor: pointer;
}

.home .more svg {
  position: relative;
}

.home .more svg {
  animation-name: animate-arrow;
  animation-duration: 0.6s;
  animation-fill-mode: both;
  animation-direction: alternate-reverse;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.home .more span {
  display: block;
  font-size: 1.125rem;
}
@media (max-width: 1280px) {
  .slide-main{ width: 70%; left: 10%;}
}

@media (max-width: 1080px) {
  .slide-main{ width: 70%; left: 5%;}
  .home-slider .slider-holder .the-text p:nth-child(2){font-size: 3rem;}
  .slick-next {  right: -20px;}
}

@media (max-width: 1024px) {
  .home-slider {
    align-items: flex-start;
  } 
}

@media (max-width: 992px) {
  .home-slider{ height: auto; padding-bottom: 40px;}
  .slide-main{ width:72%; left: 14%;}
  .slick-prev { left: -8%;}
  .slick-next {  right: -8%;}

  .thumb-main .slick-list .slick-slide div{ width: 117px; height:117px;}

  .home-slider .slider-holder .the-button { margin-top: 30px !important; margin-bottom: 30px !important;}

  .thumb-main{ width:450px; height: auto; margin: 0 auto;}
  .thumb-main .slick-list{ padding:0 50px !important;}
  .thumb-main .slick-list .slick-slide { padding: 0; visibility: hidden;}
  .thumb-main .slick-list .slick-active { visibility: visible !important;}
  .thumb-main .slick-list .slick-current {left: 0px; visibility:visible !important;}

  .testimonials .caption{padding-right: 0rem; padding-bottom: 20px;}
}
@media (max-width: 580px) {
  .the-button .wro-button span{font-size: 1.1rem;}  
  .slide-main{ width:86%; left: 8%; text-align: center;}

  .thumb-main .slick-list .slick-slide div{ width: 80px; height:80px;}

  .home-slider{ padding-bottom: 20px;}
  .home-slider .slider-holder .timing { margin: 2% 0;}
  .home-slider .slider-holder .timing span {font-size: 1rem;}
  .home-slider .slider-holder .timing span b{font-size: 1.5rem;}
  .home-slider .slider-holder .the-text p:nth-child(2) { font-size: 2.5rem;}
  .home-slider .slider-holder .the-img img { width: 150px; display: inline-block !important;}
  .slick-arrow{ width: 15px; height: 30px; background-size:100% auto;}
  .home-slider .slider-holder .the-button .wro-button { width: 170px; height: 44px;}
  .home-slider .slider-holder .the-button .wro-button::after{top: 10px; left: 10px;}

  .thumb-main{ width:100%; height: auto; left: 0;} 
  .slide-margin {margin-top:5%} 
  
}
</style>